import { CUSTOMER } from 'src/constants';

export const LOAD_CUSTOMERS = `LOAD_${CUSTOMER}S`;
export const LOAD_CUSTOMER = `LOAD_${CUSTOMER}`;
export const DELETE_CUSTOMER = `DELETE_${CUSTOMER}`;
export const EXPORT_CUSTOMER = `EXPORT_${CUSTOMER}`;
